import {generatePath} from 'react-router-dom'

import {appConfig} from '../config'
import type {Route, UrlFunctionArgs} from './types'

/**
 * defaultParams нужны как раз для случая makeRoute<RootParams>('/:tariff?')
 * если вызвать routes.root.url() без параметров, то функция вернет пустую строку,
 * а должна "/", так работает generatePath
 */
const makeRoute = <T extends UrlFunctionArgs = undefined>(
  path: string,
  defaultParams: T = {} as T,
): Route<T> => ({
  path,
  url: (params: T = defaultParams) => {
    return generatePath(path, params)
  },
})

// пути в 'appConfig.routes' и их параметры приходят в конфиге сервера
// packages/server/routes/order/index.js:27
export const routes = {
  home: makeRoute(appConfig.routes.home),
} as const
